import styled from '@emotion/styled';
import { boxSizes, colors, gutterSizes } from '../base/theme';

export const StepsContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: ${gutterSizes.base};
    padding: ${gutterSizes.large} ${gutterSizes.large} ${gutterSizes.large} ${gutterSizes.large};
    height: ${gutterSizes.large};
`;

export const StepLine = styled.div<{ active: boolean }>`
    height: ${boxSizes.borderWidth2};
    flex: 1;
    background: ${({ active }) => (active ? colors.navy : colors.newBorder)};
    transition: background 0.2s;
`;
